import { render } from "./VolcanoMap.vue?vue&type=template&id=ce745370&scoped=true&ts=true"
import script from "./VolcanoMap.vue?vue&type=script&lang=ts"
export * from "./VolcanoMap.vue?vue&type=script&lang=ts"

import "./VolcanoMap.vue?vue&type=style&index=0&id=ce745370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce745370"]])

export default __exports__